function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * dd-base-impl.ts 10.3.1
 * Copyright (c) 2021-2022 Alain Dumesny - see GridStack root license
 */
export var DDBaseImplement = /*#__PURE__*/function () {
  function DDBaseImplement() {
    _classCallCheck(this, DDBaseImplement);
    /** @internal */
    this._eventRegister = {};
  }
  /** returns the enable state, but you have to call enable()/disable() to change (as other things need to happen) */
  return _createClass(DDBaseImplement, [{
    key: "disabled",
    get: function get() {
      return this._disabled;
    }
  }, {
    key: "on",
    value: function on(event, callback) {
      this._eventRegister[event] = callback;
    }
  }, {
    key: "off",
    value: function off(event) {
      delete this._eventRegister[event];
    }
  }, {
    key: "enable",
    value: function enable() {
      this._disabled = false;
    }
  }, {
    key: "disable",
    value: function disable() {
      this._disabled = true;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      delete this._eventRegister;
    }
  }, {
    key: "triggerEvent",
    value: function triggerEvent(eventName, event) {
      if (!this.disabled && this._eventRegister && this._eventRegister[eventName]) return this._eventRegister[eventName](event);
    }
  }]);
}();